import { immerable } from "immer";
import {
  canAppearInTemplate,
  type HourlyTagCategory,
} from "@/pages/human-resources/time-management/business/hourly-tag/HourlyTagCategory.ts";

export abstract class AbstractTimeSlot {
  [immerable] = true;

  protected constructor(
    public readonly category: HourlyTagCategory | undefined,
    public readonly positionId: string | undefined,
    public readonly breakDurationMinutes: number,
  ) {}

  public abstract buildKey(): string;

  protected abstract durationMinutes(): number;

  public sameValueAs(other: AbstractTimeSlot | undefined): boolean {
    return (
      other !== undefined &&
      this.category === other.category &&
      this.positionId === other.positionId &&
      this.breakDurationMinutes === other.breakDurationMinutes
    );
  }

  public canAppearInTemplate(): boolean {
    return canAppearInTemplate(this.category);
  }

  public isWork(): boolean {
    return this.category === "WORK";
  }

  public computeWorkDurationMinutes(): number {
    return this.isWork() ?
        this.durationMinutes() - this.breakDurationMinutes
      : 0;
  }

  public computeBreakDurationMinutes(): number {
    if (this.category === "BREAK") return this.durationMinutes();
    return this.breakDurationMinutes;
  }

  public invalid(): boolean {
    return this.breakDurationMinutes >= this.durationMinutes();
  }
}
